import { Price } from './price';
var PriceDetail = /** @class */ (function () {
    function PriceDetail(price, promoPrice, promoDuration, promoLabel) {
        this.price = new Price(price);
        this.promoPrice = new Price(promoPrice);
        this.promoDuration = promoDuration;
        this.promoLabel = promoLabel;
    }
    PriceDetail.prototype.hasPromo = function () {
        return this.promoDuration > 0;
    };
    PriceDetail.prototype.hasPromoLessThanAMonth = function () {
        return this.promoDuration === 0;
    };
    return PriceDetail;
}());
export { PriceDetail };
